  <div class="d-flex post-content" *ngIf="postContent">
  <div class="post-image">
    <div class="post-image-content" [ngClass]="{'post-video': postContent.isVideo}"
         (click)="onHoverPostImage()">
      <blurry-backdrop-image
        [image]="postContent.image"
        (afterLoaded)="onLoadedPostImage()"
        (error)="onLoadPostImageError()">
      </blurry-backdrop-image>
      <ng-container *ngIf="!postContent.isVideo">
        <a class="external-link" *ngIf="postContent.postType === 'story'" href="{{postContent.channelUrl}}" target="_blank">
          <img src="assets/images/External_Link.png"/>
        </a>
        <a class="external-link" *ngIf="postContent.postType !== 'story'" href="{{postContent.url}}" target="_blank">
          <img src="assets/images/External_Link.png"/>
        </a>
      </ng-container>
      <ng-container *ngIf="postContent.isVideo">
        <a *ngIf="postContent.postType === 'story'" class="external-link" href="{{postContent.channelUrl}}" 
          target="_blank" (click)="$event.stopPropagation()">
          <img src="assets/images/External_Link.png"/>
        </a>
        <a *ngIf="postContent.postType !== 'story'" class="external-link" href="{{postContent.url}}" target="_blank" (click)="$event.stopPropagation()">
          <img src="assets/images/External_Link.png"/>
        </a>
      </ng-container>
      <post-type-display class="post-type-display" [postType]="postContent.postType"></post-type-display>
    </div>
    <div *ngIf="postContent.isVideo" class="overlay-back" (click)="onClickOutsideOverlay($event)"></div>
    <div #storyPreviewPopup
         (window:resize)="onResize($event)"
         class="story-preview-popup overlay"
         *ngIf="postContent.isVideo">
      <a class="close-story-preview" data-dismiss="modal" (click)="closeStoryPreviewPopup()" aria-label="Close">
        <img src="/assets/images/Add_Icon_White.svg" class="icon-close-popup">
      </a>
      <div class="story-content-inner">
        <achoo-story-preview #StoryReview
          [srcVideo]="getVideoLink(postContent)"
          [posterImage]="postContent.image"
          [completed]="postContent.completed"
          [isVideo]="postContent.isVideo" >
        </achoo-story-preview>
      </div>
    </div>
  </div>
  <div class="post-body d-flex flex-column">
    <div class="d-flex flex-column flex-g1">
      <div class="flex-g1 post-platform-icon">
        <img src="{{platformIconUrl}}">
      </div>
      <div class="flex-auto post-content-title text-light-font">
        <p>{{postContent.content}}</p>
      </div>
      <div class="flex-g1 post-mentions">
        <div class="d-flex flex-row flex-wrap">
          <ng-container *ngIf="postContent?.isPaidPartnership">
            <div class="align-items-center badge sponsor">
              <span class="sponsor-content">{{ 'page.post_overview.paid_promotion' | translate}}</span>
            </div>
            <div class="align-items-center badge sponsor" *ngFor="let sponsor of postSponsors">
              <span class="sponsor-content">@{{sponsor.handle}}</span>
            </div>
          </ng-container>
          <div class="align-items-center badge mention" *ngFor="let mention of postMentions">
            <span class="mention-content">{{mention}}</span>
          </div>
          <button *ngIf="allowToAddNewMention" class="badge mention add-new-mention" (click)="onAddNewMention()">
            <img src="../../../../assets/images/Add_Icon.svg" width="8" height="8"/>
          </button>
        </div>
      </div>
      <div class="d-flex flex-row flex-g1 add-new-mention-input-wrapper" *ngIf="allowToAddNewMention">
        <div class="d-flex flex-g5">
          <achoo-text-field
            [showLabel]="false"
            [model]="newMention"
            [placeholder]="'page.post_overview.new_mention_input_placeholder' | translate"
            [inputStyleModifier]="'add-new-mention-input'"
            (enterEvent)="saveNewMention($event)">
          </achoo-text-field>
        </div>
        <div class="d-flex flex-g1 align-items-center">
          <span class="cancel-icon" (click)="offAddNewMention()">
            <img src="../../../../assets/images/Delete_Dark.svg" width="8" height="8"/>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<achoo-popup #RequestErrorNotice
             [isNotification]="true"
             (cancelCallback)="onCloseRequestErrorNotice()"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{requestErrorMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-content/post-content.component.html